<template>
  <section class="section">
    <div class="glass-container animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Sorteos Metropolitan</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Selección aleatoria de ganadores con alta precisión</p>
          </div>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-6 has-text-centered">
          <b-field class="is-flex is-justify-content-center mb-6 glass-field">
            <b-radio-button v-model="modo" native-value="juego" class="mr-4">
              <b-icon icon="gamepad-variant" size="is-small" class="mr-2" />
              <span>Jugadores</span>
            </b-radio-button>
            <b-radio-button v-model="modo" native-value="calificaciones">
              <b-icon icon="star" size="is-small" class="mr-2" />
              <span>Calificaciones</span>
            </b-radio-button>
          </b-field>

          <div class="ruleta-outer mb-6 animate__animated animate__zoomIn">
            <div class="ruleta-inner glass-card" :class="{ 'is-girando': girando }">
              <div v-if="!nombreActual" class="has-text-grey-light">
                <b-icon icon="clover" size="is-large" class="mb-2" />
                <p class="is-size-5">Esperando para iniciar...</p>
                <p class="is-size-7 mt-2" v-if="participantes.length > 0">
                  {{ participantes.length }} candidatos cargados
                </p>
              </div>
              <div v-else class="animate__animated animate__pulse animate__infinite">
                <p class="is-size-2 has-text-weight-bold has-text-white">{{ nombreActual }}</p>
                <p class="is-size-6 has-text-primary" v-if="correoActual">{{ correoActual }}</p>
              </div>
            </div>
          </div>

          <div class="buttons is-centered">
            <b-button 
              v-if="!girando"
              type="is-primary" 
              size="is-large" 
              icon-left="play-circle" 
              class="is-rounded glass-btn-primary px-6"
              @click="iniciar"
              :disabled="participantes.length === 0"
            >
              ¡Girar Ruleta!
            </b-button>
            <b-button 
              v-else
              type="is-danger" 
              size="is-large" 
              icon-left="stop-circle" 
              class="is-rounded glass-btn-danger px-6 animate__animated animate__pulse animate__infinite"
              @click="detener"
            >
              ¡Detener Ganador!
            </b-button>
          </div>

          <div v-if="ganadorFinal" class="mt-6 animate__animated animate__bounceIn">
            <div class="notification is-success glass-winner">
              <b-icon icon="trophy" size="is-large" class="mb-2" />
              <h3 class="title is-3 has-text-white mb-2">¡Felicidades!</h3>
              <p class="is-size-4 has-text-weight-bold">{{ ganadorFinal.nombre }}</p>
              <p class="is-size-6 opacity-7">{{ ganadorFinal.correo || ganadorFinal.cedula }}</p>
            </div>
          </div>

          <p v-if="participantes.length === 0 && !cargando" class="has-text-grey-light mt-4">
            No hay participantes disponibles en esta categoría para el evento seleccionado.
          </p>
        </div>
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import HttpService from "@/Servicios/HttpService";

export default {
  name: "SorteosComponent",
  data() {
    return {
      participantes: [],
      modo: "juego",
      girando: false,
      intervalId: null,
      nombreActual: "",
      correoActual: "",
      cargando: false,
      ganadorFinal: null,
      lastIndices: [] // Para evitar repeticiones inmediatas
    };
  },
  mounted() {
    this.cargarParticipantes();
    document.title = 'Metropolitan - Sorteos';
  },
  watch: {
    modo() {
      this.cargarParticipantes();
    },
  },
  methods: {
    async cargarParticipantes() {
      this.cargando = true;
      this.ganadorFinal = null;
      this.nombreActual = "";
      try {
        const res = await HttpService.obtenerConConsultas("sorteos.php", { accion: this.modo });
        // Mezclamos la lista al cargarla para mayor aleatoriedad
        this.participantes = this.shuffle(res || []);
      } catch (e) {
        console.error(e);
      } finally {
        this.cargando = false;
      }
    },
    shuffle(array) {
      let currentIndex = array.length, randomIndex;
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
      }
      return array;
    },
    iniciar() {
      if (!this.participantes.length) return;
      this.girando = true;
      this.ganadorFinal = null;
      let speed = 60;
      
      this.intervalId = setInterval(() => {
        let newIndex;
        // Solo intentar evitar repeticiones si hay suficientes participantes (>1)
        if (this.participantes.length > 1) {
             let attempts = 0;
             do {
               newIndex = Math.floor(Math.random() * this.participantes.length);
               attempts++;
             } while (this.lastIndices.includes(newIndex) && attempts < 10);
        } else {
             newIndex = 0;
        }

        this.lastIndices.push(newIndex);
        if (this.lastIndices.length > Math.min(5, Math.max(0, this.participantes.length - 1))) {
            this.lastIndices.shift();
        }

        const p = this.participantes[newIndex];
        this.nombreActual = p.nombre || p.usuario || 'Invitado';
        this.correoActual = p.correo || p.telefono || '';
      }, speed);
    },
    detener() {
      clearInterval(this.intervalId);
      this.girando = false;
      
      // Seleccionamos el ganador final de forma verdaderamente aleatoria de la lista barajada
      const finalIndex = Math.floor(Math.random() * this.participantes.length);
      this.ganadorFinal = this.participantes[finalIndex];
      this.nombreActual = this.ganadorFinal.nombre || this.ganadorFinal.usuario;
      this.correoActual = this.ganadorFinal.correo || this.ganadorFinal.telefono;

      this.$buefy.toast.open({
        message: `¡Ganador seleccionado: ${this.nombreActual}!`,
        type: 'is-success',
        duration: 5000
      });
    },
  },
};
</script>

<style scoped>
.glass-container {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 32px;
  padding: 60px 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 80vh;
  box-shadow: 0 40px 100px rgba(0,0,0,0.4);
}

.ruleta-outer {
  display: inline-block;
  padding: 15px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(37, 99, 235, 0) 100%);
  border-radius: 100%;
}

.ruleta-inner {
  width: 350px;
  height: 350px;
  border-radius: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.8) !important;
  border: 4px solid rgba(59, 130, 246, 0.3) !important;
  box-shadow: 0 0 60px rgba(59, 130, 246, 0.1);
  padding: 40px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.is-girando {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 80px rgba(59, 130, 246, 0.4);
  transform: scale(1.05) rotate(5deg);
}

.glass-field /deep/ .b-radio.button {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #94a3b8 !important;
  border-radius: 16px !important;
  padding: 0 25px;
  height: 45px;
}

.glass-field /deep/ .b-radio.button.is-selected {
  background: #3b82f6 !important;
  color: white !important;
  border-color: transparent !important;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.2);
}

.glass-btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  border: none;
  font-weight: 700;
  height: 60px;
  box-shadow: 0 10px 30px rgba(59, 130, 246, 0.3);
}

.glass-btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);
  border: none;
  font-weight: 700;
  height: 60px;
  box-shadow: 0 10px 30px rgba(239, 68, 68, 0.3);
}

.glass-winner {
  background: rgba(16, 185, 129, 0.1) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(16, 185, 129, 0.3) !important;
  border-radius: 24px;
  padding: 30px;
}

@media screen and (max-width: 600px) {
  .ruleta-inner {
    width: 280px;
    height: 280px;
  }
  .is-size-2 { font-size: 1.5rem !important; }
}
</style>
